export default __webpack_public_path__ + "static/media/desk002.992e0bfa.jpeg";